module.exports = __webpack_public_path__ + "img/slide-19.59d88125.jpeg";